import { render, staticRenderFns } from "./OrderSalaryHistoryDialog.vue?vue&type=template&id=6d673e9e&scoped=true"
import script from "./OrderSalaryHistoryDialog.vue?vue&type=script&lang=js"
export * from "./OrderSalaryHistoryDialog.vue?vue&type=script&lang=js"
import style0 from "./OrderSalaryHistoryDialog.vue?vue&type=style&index=0&id=6d673e9e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d673e9e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d673e9e')) {
      api.createRecord('6d673e9e', component.options)
    } else {
      api.reload('6d673e9e', component.options)
    }
    module.hot.accept("./OrderSalaryHistoryDialog.vue?vue&type=template&id=6d673e9e&scoped=true", function () {
      api.rerender('6d673e9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/employeeSalary/OrderSalaryHistoryDialog.vue"
export default component.exports